<template>
  <svg
    v-if="type === ICON_LIST.CHECK"
    width="270"
    height="191"
    viewBox="0 0 270 191"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M101.333 146.224L246.873 0.667969L269.277 23.0563L101.333 191L0.569824 90.2371L22.9582 67.8488L101.333 146.224Z" />
  </svg>

  <svg
    v-else-if="type === ICON_LIST.CLOSE"
    width="202"
    height="202"
    viewBox="0 0 202 202"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M101 78.6152L179.375 0.240234L201.763 22.6286L123.388 101.004L201.763 179.379L179.375 201.767L101 123.392L22.6249 201.767L0.236572 179.379L78.6116 101.004L0.236572 22.6286L22.6249 0.240234L101 78.6152Z" />
  </svg>

  <svg
    v-else-if="type === ICON_LIST.CUP"
    width="318"
    height="286"
    viewBox="0 0 318 286"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M222.333 158.833V32.1667H64V158.833C64 167.232 67.3363 175.286 73.2749 181.225C79.2136 187.164 87.2681 190.5 95.6666 190.5H190.667C199.065 190.5 207.12 187.164 213.058 181.225C218.997 175.286 222.333 167.232 222.333 158.833ZM48.1666 0.5H285.667C294.065 0.5 302.12 3.8363 308.058 9.77495C313.997 15.7136 317.333 23.7681 317.333 32.1667V79.6667C317.333 88.0652 313.997 96.1197 308.058 102.058C302.12 107.997 294.065 111.333 285.667 111.333H254V158.833C254 175.63 247.327 191.739 235.45 203.617C223.573 215.494 207.464 222.167 190.667 222.167H95.6666C78.8696 222.167 62.7605 215.494 50.8832 203.617C39.0059 191.739 32.3333 175.63 32.3333 158.833V16.3333C32.3333 12.1341 34.0014 8.1068 36.9708 5.13748C39.9401 2.16815 43.9674 0.5 48.1666 0.5ZM254 32.1667V79.6667H285.667V32.1667H254ZM0.666626 253.833H285.667V285.5H0.666626V253.833Z" />
  </svg>

  <svg
    v-else-if="type === ICON_LIST.PAPERS"
    width="318"
    height="318"
    viewBox="0 0 318 318"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M269.833 317.334H48.1667C35.5689 317.334 23.4871 312.329 14.5791 303.421C5.67111 294.513 0.666656 282.431 0.666656 269.834V16.5003C0.666656 12.3011 2.33481 8.27379 5.30413 5.30447C8.27346 2.33514 12.3007 0.666992 16.5 0.666992H238.167C242.366 0.666992 246.393 2.33514 249.363 5.30447C252.332 8.27379 254 12.3011 254 16.5003V206.5H317.333V269.834C317.333 282.431 312.329 294.513 303.421 303.421C294.513 312.329 282.431 317.334 269.833 317.334ZM254 238.167V269.834C254 274.033 255.668 278.06 258.637 281.03C261.607 283.999 265.634 285.667 269.833 285.667C274.033 285.667 278.06 283.999 281.029 281.03C283.999 278.06 285.667 274.033 285.667 269.834V238.167H254ZM222.333 285.667V32.3337H32.3333V269.834C32.3333 274.033 34.0015 278.06 36.9708 281.03C39.9401 283.999 43.9674 285.667 48.1667 285.667H222.333ZM64 79.8337H190.667V111.5H64V79.8337ZM64 143.167H190.667V174.834H64V143.167ZM64 206.5H143.167V238.167H64V206.5Z" />
  </svg>

  <svg
    v-else-if="type === ICON_LIST.TAG"
    width="330"
    height="330"
    viewBox="0 0 330 330"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M150.583 0.250977L307.317 22.6551L329.705 179.405L184.165 324.945C181.196 327.913 177.17 329.581 172.971 329.581C168.773 329.581 164.746 327.913 161.777 324.945L5.02714 168.195C2.05885 165.226 0.391357 161.199 0.391357 157.001C0.391357 152.803 2.05885 148.776 5.02714 145.807L150.583 0.250977ZM161.777 33.8493L38.6096 157.001L172.971 291.347L296.123 168.195L279.34 50.6326L161.777 33.8493ZM195.344 134.613C189.404 128.671 186.068 120.613 186.069 112.211C186.07 108.051 186.89 103.931 188.483 100.088C190.076 96.2452 192.41 92.7533 195.352 89.8122C198.294 86.8711 201.787 84.5383 205.63 82.947C209.474 81.3556 213.593 80.537 217.754 80.5377C226.155 80.5392 234.212 83.8782 240.152 89.8201C246.092 95.7621 249.428 103.82 249.427 112.222C249.425 120.624 246.086 128.681 240.144 134.621C234.202 140.56 226.144 143.897 217.742 143.895C209.341 143.894 201.284 140.555 195.344 134.613Z" />
  </svg>
</template>


<script>
import ICON_LIST from './WindowscreenIcons';

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ICON_LIST
    }
  }
}

</script>

<style scoped lang="scss">

svg {
  fill: currentColor;
}

</style>